import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'

const module = 'boardsides'
let doc = {
  list: {
    name: 'Coté de panneau',
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    actions: [
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['boardsides.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
  },

  form: {
    name: 'Coté',
    fields: [
      { label: 'Titre', name: 'name', type: 'text', hint: 'Comment vous souhaitez nommer ce coté' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['boardsides.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        isFlat: true,
        scope: ['boardsides.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
  },

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

export default crudmaker(module, apiClient, doc)
